import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

export const deleteLimitData = ({ id }) => {
  return axios.delete(`/paymentOptionsLimit/${id}`);
};

deleteLimitData.propTypes = {
  id: PropTypes.string.isRequired,
};

export const useDeleteLimitData = ({ providerId, config }) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async (deletedLimit) => {
      await queryClient.cancelQueries('provider_limits');

      const previousLimits = queryClient.getQueryData('provider_limits');

      queryClient.setQueryData(
        'provider_limits',
        previousLimits?.filter((limitData) => limitData.id !== deletedLimit.id)
      );

      return { previousLimits };
    },
    onError: (_, __, context) => {
      if (context?.previousLimits) {
        queryClient.setQueryData('provider_limits', context.previousLimits);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['provider_limits', providerId]);
      addNotification({
        type: 'success',
        title: 'Limit deleted',
      });
    },
    ...config,
    mutationFn: deleteLimitData,
  });
};
